export const HANDOVER_CAPSULE_COPY = {
  title: 'Handover Capsule',
  summary:
    'A sealed internal container for manual uploads that helps AI draft most of the handover package.',
  bullets: [
    'Manual uploads only. No Dropbox, Gmail, Outlook, Slack, or other external sync is involved.',
    'Departing employees choose what to upload: PDFs, exported messages, documents, presentations, and similar source material.',
    'AI uses supported uploaded files to extract relevant knowledge and draft the handover, then the working context is cleared.',
  ],
  currentState:
    'Current rollout: the capsule now stores uploads server-side, supports sealing, and can generate a first-draft departure package from supported file types.',
  acceptedFileLabels: ['PDF', 'DOCX', 'PPTX', 'TXT', 'CSV', 'ZIP', 'EML', 'JSON'],
  currentSupportedExtensions: ['pdf', 'txt', 'csv', 'json', 'eml'],
  supportedNowNote:
    'PDF, TXT, CSV, JSON, and EML files are used for AI drafting today. Other uploads stay sealed in the capsule but are excluded from the draft until their parsers are added.',
} as const;
